import { ThemeProvider } from "react-jss";
import Routing from "./routes";
import { useAppSelector } from "./components/hooks";
import { AppReloadPrompt } from "./components/common/AppReloadPrompt/AppReloadPrompt";

function App() {
  const theme = useAppSelector((state) => state.theme);

  return (
    <ThemeProvider theme={theme.theme}>
      <Routing />
      <AppReloadPrompt />
    </ThemeProvider>
  );
}

export default App;
